"use client";

import { EdgenModalCreateAble } from "@components/EdgenModal";
import { callEdgenModalWhenRootReadyAsync } from "@components/EdgenModal/waitForEdgenModalRoot";
import { PlanUnlockedMovesModalContent } from "./PlanUnlockedMovesModalContent";
import { PLAN_UNLOCKED_MOVES_MODAL_PROPS } from "./planUnlockedMovesModalShell";
import type { OpenPlanUnlockedMovesModalParams } from "./types";

let pendingPlanUnlockedMovesModal: Promise<void> | null = null;

export const closePlanUnlockedMovesModal = (): void => {
  EdgenModalCreateAble.end(false);
  pendingPlanUnlockedMovesModal = null;
};

/**
 * Plan – Unlocked moves modal from save_goal View details / hasResult drill-down.
 */
export const openPlanUnlockedMovesModal = (
  params: OpenPlanUnlockedMovesModalParams & {
    isActivating?: boolean;
  },
): Promise<void> => {
  if (pendingPlanUnlockedMovesModal) {
    return pendingPlanUnlockedMovesModal;
  }

  pendingPlanUnlockedMovesModal = callEdgenModalWhenRootReadyAsync(
    () =>
      new Promise<void>((resolve) => {
        let settled = false;

        const finish = () => {
          if (settled) {
            return;
          }
          settled = true;
          pendingPlanUnlockedMovesModal = null;
          EdgenModalCreateAble.end(false);
          resolve();
        };

        EdgenModalCreateAble.call({
          children: (
            <PlanUnlockedMovesModalContent
              args={params.args}
              mode={params.mode}
              isActivating={params.isActivating}
              onActivate={async () => {
                await params.onActivate?.();
              }}
              onClose={finish}
            />
          ),
          ...PLAN_UNLOCKED_MOVES_MODAL_PROPS,
        });
      }),
  ).catch((error) => {
    pendingPlanUnlockedMovesModal = null;
    throw error;
  });

  return pendingPlanUnlockedMovesModal;
};
